export const pathsToExclude = [
  '/online-call-form',
  '/quote',
  '/bookings',
  '/login',
  '/request-manager',
  '/pl',
  '/intl',
];
